import {
  setCurrencies as publicSetCurrencies,
  getCurrencies as publicGetCurrencies,
} from './settings-v1-site-currency-site-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const setCurrencies: MaybeContext<
  BuildRESTFunction<typeof publicSetCurrencies> & typeof publicSetCurrencies
> = /*#__PURE__*/ createRESTModule(publicSetCurrencies);
export const getCurrencies: MaybeContext<
  BuildRESTFunction<typeof publicGetCurrencies> & typeof publicGetCurrencies
> = /*#__PURE__*/ createRESTModule(publicGetCurrencies);

export {
  SiteCurrency,
  SetCurrenciesRequest,
  SetCurrenciesResponse,
  GetCurrenciesRequest,
  GetCurrenciesResponse,
  SetCheckoutCurrenciesRequest,
  SetCheckoutCurrenciesResponse,
  GetCheckoutCurrenciesRequest,
  GetCheckoutCurrenciesResponse,
  SetCurrenciesOptions,
} from './settings-v1-site-currency-site-settings.universal.js';
